<template>
    <v-main>
        <!-- search -->
        <tablePtenAction typeList="search" @setTitle="setTitle"/>
         <!-- navBar -->
        <navbarPten menuIndex="4" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbarPten from '@/components/pten/navbarPten.vue';
    import tablePtenAction from '@/components/pten/tablePtenAction.vue';

    export default {
        components: {
            navbarPten,
            tablePtenAction,
        },
        props: {
            option: {
                type: String,
                required: false,
                default: "",
            },
        },
        data() {
            return {
                menuTitle: "ARES - Lead actions",
            }
        },
        computed: {
            list() {
                return this.option==='all' ? "searchAll" : "search";
            }
        },
        mounted() {
            document.title = "ARES - Leads";
        },
        methods: {
            setTitle(agentName) {
                this.menuTitle = agentName === "" || this.option === "all" ? "ARES - Lead actions" : "ARES - actions - " + agentName;
            },
            actionClick(action) {
                switch (action) {       
                    default:
                        break;
                }
            },
        }
    };
</script> 
